import { Link, type RouteObject } from 'react-router-dom';
import { ROUTE_PATHS } from '@/constants/common';

export const dashboardRoute: RouteObject = {
  path: ROUTE_PATHS.dashboard,
  lazy: async () => ({
    Component: (await import('@/pages/Dashboard')).Dashboard,
  }),
  handle: {
    title: '仪表盘',
    crumb: () => <Link to={ROUTE_PATHS.dashboard}>仪表盘</Link>,
  },
};
